/* ==========================================================================
   Bundle picker
   The product page's primary selector: one shared duration, one or more
   packages, added together as separate line items.

   Also drives everything the old single-variant picker did:
   per-day pricing, savings badges, the upgrade nudge, the hardware notice
   and the sticky mobile bar.

   Discount percentages are display only. Real bundle pricing must exist as
   an automatic discount in Shopify admin, or checkout will not match.
   ========================================================================== */
(function () {
  'use strict';

  var T = window.RaidTheme || {};

  /* ---------- money ---------- */
  function money(cents, format) {
    var fmt = format || T.moneyFormat || '${{amount}}';
    function num(v, p) {
      if (isNaN(v)) v = 0;
      var parts = (v / 100).toFixed(p === undefined ? 2 : p).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
      return parts[1] ? whole + '.' + parts[1] : whole;
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, n) {
      if (n === 'amount_no_decimals') return num(cents, 0);
      if (n === 'amount_with_comma_separator') return num(cents, 2).replace(/,/g, '§').replace(/\./g, ',').replace(/§/g, '.');
      return num(cents, 2);
    });
  }

  /* ---------- duration parsing (plurals matter: "7 Days") ---------- */
  function parseDays(value) {
    if (!value) return null;
    var s = String(value).toLowerCase().trim();
    if (/life ?time|permanent|forever|unlimited/.test(s)) return null;
    var m = s.match(/(\d+(?:\.\d+)?)\s*(?:days?|d)\b/);   if (m) return parseFloat(m[1]);
    m = s.match(/(\d+(?:\.\d+)?)\s*(?:weeks?|wks?|w)\b/); if (m) return parseFloat(m[1]) * 7;
    m = s.match(/(\d+(?:\.\d+)?)\s*(?:months?|mos?|m)\b/);if (m) return parseFloat(m[1]) * 30;
    m = s.match(/(\d+(?:\.\d+)?)\s*(?:years?|yrs?|y)\b/); if (m) return parseFloat(m[1]) * 365;
    m = s.match(/^(\d+(?:\.\d+)?)$/);                     if (m) return parseFloat(m[1]);
    return null;
  }

  function Picker(root) {
    var dataEl = root.querySelector('[data-bundle-data]');
    if (!dataEl) return;
    try { this.data = JSON.parse(dataEl.textContent); }
    catch (e) { console.warn('[bundle] bad data', e); return; }

    this.root = root;
    this.variants = this.data.variants || [];
    this.pickAxis = this.data.pickAxis;
    this.sharedAxis = this.data.sharedAxis;
    this.tiers = this.data.tiers || [];
    this.single = this.data.single === true;
    this.hardware = this.data.hardware || {};
    this.showPerDay = this.data.showPerDay !== false;
    this.showSavings = this.data.showSavings !== false;

    this.partial = {};
    var pEl = document.querySelector('[data-hardware-partial]');
    if (pEl) { try { this.partial = JSON.parse(pEl.textContent) || {}; } catch (e) {} }

    this.optionCopy = {};
    var cEl = root.querySelector('[data-option-copy]');
    if (cEl) { try { this.optionCopy = JSON.parse(cEl.textContent) || {}; } catch (e) {} }

    this.featureText = '';
    var fEl = root.querySelector('[data-option-features]');
    if (fEl) { try { this.featureText = JSON.parse(fEl.textContent) || ''; } catch (e) {} }

    /* Demo videos, keyed by option name. Authored as a metafield so the URLs
       can be changed without touching this file. */
    this.optionVideos = {};
    var vEl = root.querySelector('[data-option-videos]');
    if (vEl) { try { this.optionVideos = JSON.parse(vEl.textContent) || {}; } catch (e) {} }

    this.selected = [];
    this.shared = null;

    this.buildBuyNow();
    this.bind();
    this.chooseDefaults();
    this.readState();
    this.update();
  }

  /* Buy now sits above Add to cart. Shopify's native dynamic checkout button
     cannot be used here: this picker posts several line items through
     /cart/add.js, which a standard product form cannot express. So the button
     is created here, adds the selection, then goes straight to checkout. */
  Picker.prototype.buildBuyNow = function () {
    var add = document.querySelector('[data-add-button]');
    if (!add || document.querySelector('[data-buy-now]')) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'btn btn--secondary btn--block buy-now';
    btn.setAttribute('data-buy-now', '');
    btn.innerHTML = '<span data-buy-now-label>Buy now</span>';

    add.parentNode.insertBefore(btn, add);
    this.buyNow = btn;
  };

  /* Liquid ticks the first package and first term, but the first package may
     be sold out and the shortest term is rarely the one we want to lead with.
     Pick the first genuinely available package, and prefer the configured
     default term (30 days) when it exists. */
  Picker.prototype.chooseDefaults = function () {
    var self = this;
    var terms = [].slice.call(this.root.querySelectorAll('[data-bundle-shared]'));
    var picks = [].slice.call(this.root.querySelectorAll('[data-bundle-pick]'));

    /* Single-option products only have rows, so preselect the first one
       that is actually buyable rather than a sold-out first entry. */
    if (this.single) {
      if (!terms.length) return;
      var live = terms.filter(function (t) {
        var v = self.variantFor(null, t.value);
        return v && v.available;
      })[0] || terms[0];
      terms.forEach(function (t) { t.checked = (t === live); });
      this.shared = live.value;
      return;
    }

    if (!terms.length || !picks.length) return;

    var preferred = this.data.defaultTerm || '';

    function worksWith(term) {
      return picks.some(function (p) {
        var v = self.variantFor(p.value, term);
        return v && v.available;
      });
    }

    // 1. the configured default term, if anything is buyable on it
    var chosen = terms.filter(function (t) {
      return t.value === preferred && worksWith(t.value);
    })[0];

    // 2. otherwise the first term with any available package
    if (!chosen) {
      chosen = terms.filter(function (t) { return worksWith(t.value); })[0];
    }

    // 3. last resort: leave Liquid's choice
    if (!chosen) chosen = terms[0];

    terms.forEach(function (t) { t.checked = (t === chosen); });
    this.shared = chosen.value;

    // now tick the first package that is actually available on that term
    var firstOk = picks.filter(function (p) {
      var v = self.variantFor(p.value, chosen.value);
      return v && v.available;
    })[0];

    picks.forEach(function (p) { p.checked = (p === firstOk); });
  };

  Picker.prototype.variantFor = function (pick, shared) {
    var self = this;
    /* Single-option products have no second axis to cross-reference, so the
       one option value identifies the variant on its own. */
    if (this.single) {
      var key = shared != null ? shared : pick;
      return this.variants.filter(function (v) {
        return v.options[0] === key;
      })[0] || null;
    }
    return this.variants.filter(function (v) {
      return v.options[self.pickAxis] === pick && v.options[self.sharedAxis] === shared;
    })[0] || null;
  };

  /* The automatic discount in admin only covers open-ended terms, so a dated
     term must not advertise a bundle saving it will not get at checkout.
     parseDays returns null exactly for Lifetime/Permanent/Forever/Unlimited,
     which is the same test the rest of the file uses for "no per-day rate". */
  function termQualifies(term) {
    return !!term && parseDays(term) === null;
  }

  /* n packages on `term`. Pass the term explicitly: paintTerms prices every
     row, not just the selected one, so reading this.shared here would give
     every row the selected row's discount. */
  Picker.prototype.tierFor = function (n, term) {
    if (!termQualifies(arguments.length > 1 ? term : this.shared)) return null;
    var best = null;
    this.tiers.forEach(function (t) {
      if (n >= t.count && (!best || t.count > best.count)) best = t;
    });
    return best;
  };

  Picker.prototype.readState = function () {
    var self = this;

    /* Single-option products: the chosen row is the whole selection. There
       are no packages to combine, so selection and term are the same value. */
    if (this.single) {
      var row = this.root.querySelector('[data-bundle-shared]:checked');
      if (row) {
        this.shared = row.value;
        this.selected = [row.value];
      } else {
        // no options at all — the hidden input already carries the variant
        this.shared = null;
        this.selected = this.variants.length ? [this.variants[0].options[0]] : [];
      }
      return;
    }

    this.selected = [];
    this.root.querySelectorAll('[data-bundle-pick]').forEach(function (el) {
      if (el.checked && !el.disabled) self.selected.push(el.value);
    });
    var s = this.root.querySelector('[data-bundle-shared]:checked');
    if (s) this.shared = s.value;

    // A sold-out combination must never stay ticked, or the total would
    // include something that cannot be bought.
    this.selected = this.selected.filter(function (val) {
      var v = self.variantFor(val, self.shared);
      return v && v.available;
    });

    // Switching duration can strand the selection: the only ticked package
    // may be sold out on the new term. Fall back to the first package that
    // is buyable there, so the box is never left empty.
    if (!this.selected.length) {
      var picks = [].slice.call(this.root.querySelectorAll('[data-bundle-pick]'));
      var firstOk = picks.filter(function (p) {
        var v = self.variantFor(p.value, self.shared);
        return v && v.available;
      })[0];
      if (firstOk) {
        firstOk.checked = true;
        this.selected = [firstOk.value];
      }
    }
  };

  Picker.prototype.bind = function () {
    var self = this;
    this.root.addEventListener('change', function (e) {
      if (!e.target.matches('[data-bundle-pick],[data-bundle-shared]')) return;

      // Unticking the last package would leave nothing to buy and a $0.00
      // total, so refuse it and keep the box ticked.
      if (e.target.matches('[data-bundle-pick]') && !e.target.checked) {
        var live = [].slice.call(self.root.querySelectorAll('[data-bundle-pick]'))
          .filter(function (el) { return el.checked && !el.disabled; });
        if (!live.length) {
          e.target.checked = true;
          return;
        }
      }

      self.readState();
      self.update();
    });
    var btn = document.querySelector('[data-add-button]');
    if (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); self.add(false); });
    }
    var buy = document.querySelector('[data-buy-now]');
    if (buy) {
      buy.addEventListener('click', function (e) { e.preventDefault(); self.add(true); });
    }
    var sticky = document.querySelector('[data-sticky-add]');
    if (sticky) sticky.addEventListener('click', function () { self.add(false); });
  };

  /* the shortest available term is the savings baseline */
  Picker.prototype.baselineRate = function (pickValue) {
    var self = this, best = null;
    this.variants.forEach(function (v) {
      if (v.options[self.pickAxis] !== pickValue || !v.available) return;
      var d = parseDays(v.options[self.sharedAxis]);
      if (!d) return;
      if (!best || d < best.days) best = { days: d, price: v.price };
    });
    return best ? best.price / best.days : null;
  };

  Picker.prototype.update = function () {
    var self = this;
    var items = [], subtotal = 0;

    this.selected.forEach(function (val) {
      var v = self.variantFor(val, self.shared);
      if (v && v.available) { items.push(v); subtotal += v.price; }
    });

    var tier = this.tierFor(items.length);
    var pct = tier ? tier.percent : 0;
    var discounted = Math.round(subtotal * (1 - pct / 100));

    this.paintPicks();
    this.paintTerms();
    this.paintTotals(items, subtotal, discounted, pct);
    this.paintHint(items.length);
    this.paintHardware();
    this.paintCopy();
    this.paintVideos();
    this.paintUpgrade(items, discounted);

    this.current = items;
    this.pct = pct;
  };

  /* Upgrade nudge: is a longer term meaningfully cheaper per day for the
     current bundle? Silent under 10% so it never oversells a small saving. */
  Picker.prototype.paintUpgrade = function (items, discounted) {
    var box = document.querySelector('[data-upgrade-nudge]');
    if (!box) return;

    var days = parseDays(this.shared);
    if (!days || !items.length) { box.hidden = true; return; }

    var self = this;
    var currentRate = discounted / days;
    var best = null;

    this.root.querySelectorAll('[data-bundle-shared]').forEach(function (input) {
      var term = input.value;
      var d = parseDays(term);
      if (!d || d <= days) return;

      var total = 0, ok = true;
      self.selected.forEach(function (pickVal) {
        var v = self.variantFor(pickVal, term);
        if (v && v.available) total += v.price; else ok = false;
      });
      if (!ok || !total) return;

      var tier = self.tierFor(self.selected.length, term);
      var pct = tier ? tier.percent : 0;
      total = Math.round(total * (1 - pct / 100));

      if (!best || d < best.days) best = { days: d, term: term, total: total };
    });

    if (!best) { box.hidden = true; return; }

    var saving = Math.round((1 - (best.total / best.days) / currentRate) * 100);
    if (saving < 10) { box.hidden = true; return; }

    var label = box.querySelector('[data-upgrade-text]');
    var action = box.querySelector('[data-upgrade-action]');
    var tpl = box.dataset.template || 'Go [term] and pay [saving] less per day.';

    if (label) {
      label.innerHTML = tpl
        .replace(/\[term\]/g, '<strong>' + best.term + '</strong>')
        .replace(/\[saving\]/g, '<strong>' + saving + '%</strong>')
        .replace(/\[price\]/g, money(best.total))
        .replace(/\[perday\]/g, money(Math.round(best.total / best.days)));
    }
    if (action) {
      action.textContent = (box.dataset.actionText || 'Switch').replace(/\[term\]/g, best.term);
      action.onclick = function () {
        var target = self.root.querySelector('[data-bundle-shared][value="' + best.term.replace(/"/g, '\\"') + '"]');
        if (target) { target.checked = true; self.readState(); self.update(); }
      };
    }
    box.hidden = false;
  };

  /* per-package price, or a sold-out marker, on each checkbox row */
  Picker.prototype.paintPicks = function () {
    var self = this;
    var soldOut = (T.strings && T.strings.soldOut) || 'Sold out';

    this.root.querySelectorAll('[data-bundle-pick]').forEach(function (el) {
      var v = self.variantFor(el.value, self.shared);
      var off = !v || !v.available;
      var wrap = el.closest('[data-bundle-row]');

      el.disabled = off;
      if (off && el.checked) el.checked = false;   // never leave a dead pick ticked

      if (!wrap) return;
      wrap.classList.toggle('is-off', off);
      wrap.setAttribute('aria-disabled', String(off));

      var p = wrap.querySelector('[data-bundle-price]');
      if (!p) return;
      if (off) {
        p.textContent = soldOut;
        p.classList.add('is-soldout');
      } else {
        p.textContent = money(v.price);
        p.classList.remove('is-soldout');
      }
    });

    // the sole remaining pick cannot be unticked, so stop it looking clickable
    var ticked = [].slice.call(this.root.querySelectorAll('[data-bundle-pick]'))
      .filter(function (el) { return el.checked && !el.disabled; });
    this.root.querySelectorAll('[data-bundle-row]').forEach(function (row) {
      var input = row.querySelector('[data-bundle-pick]');
      row.classList.toggle('is-locked', ticked.length === 1 && input === ticked[0]);
    });
  };

  /* per-day + savings on each duration row, priced for the current selection */
  Picker.prototype.paintTerms = function () {
    var self = this;
    var basis = this.selected.length ? this.selected : [];

    this.root.querySelectorAll('[data-bundle-shared]').forEach(function (input) {
      var term = input.value;
      var days = parseDays(term);
      var wrap = input.closest('.row-opt');
      if (!wrap) return;

      var total = 0, any = false;

      /* In single mode each row IS its own variant, so it is priced on its
         own rather than summed across the current selection. */
      if (self.single) {
        var own = self.variantFor(null, term);
        if (own && own.available) { total = own.price; any = true; }
      } else {
        basis.forEach(function (pickVal) {
          var v = self.variantFor(pickVal, term);
          if (v && v.available) { total += v.price; any = true; }
        });
      }

      var priceEl = wrap.querySelector('[data-shared-price]');
      var saveEl  = wrap.querySelector('[data-shared-save]');

      // a term with nothing available for the current picks is unbuyable
      var dead = self.single ? !any : (basis.length > 0 && !any);
      input.disabled = dead;
      wrap.classList.toggle('is-off', dead);

      // the row shows what this term actually costs, bundle discount included
      // (only where the discount applies — `term`, not the selected term)
      var tier = self.tierFor(basis.length, term);
      var pct = tier ? tier.percent : 0;
      var charged = Math.round(total * (1 - pct / 100));

      if (priceEl) {
        if (dead) {
          priceEl.textContent = (T.strings && T.strings.soldOut) || 'Sold out';
          priceEl.classList.add('is-soldout');
        } else {
          priceEl.textContent = any ? money(charged) : '';
          priceEl.classList.remove('is-soldout');
        }
      }

      if (saveEl) {
        saveEl.innerHTML = '';
        if (self.showSavings && any && basis.length) {
          var saved = null;

          if (days) {
            /* Savings are measured against buying the same packages on the
               shortest term for the same number of days, at full price. That
               is the real alternative, so the badge reflects both the longer
               term and the multi-pack discount in one number. */
            var baseRate = 0, ok = true;
            if (self.single) {
              /* Compare against the shortest term of this same product, so a
                 "1 Month vs Lifetime" pair still shows a meaningful saving. */
              var best = null;
              self.variants.forEach(function (v) {
                if (!v.available) return;
                var d = parseDays(v.options[0]);
                if (!d) return;
                if (!best || d < best.days) best = { days: d, price: v.price };
              });
              if (best) baseRate = best.price / best.days; else ok = false;
            } else {
              basis.forEach(function (pickVal) {
                var r = self.baselineRate(pickVal);
                if (r === null) ok = false; else baseRate += r;
              });
            }
            if (ok && baseRate > 0) {
              saved = Math.round((1 - charged / (baseRate * days)) * 100);
            }
          }

          /* An open-ended term ("Lifetime") has no per-day rate, so there is
             no term saving to compute — but the bundle discount is still real
             and charged. Falling back to it keeps the badge on every row that
             actually saves money, rather than only the dated ones. */
          if (saved === null && pct > 0) saved = pct;

          if (saved !== null && saved >= 5) {
            var b = document.createElement('span');
            b.className = 'badge-save';
            b.textContent = 'Save ' + saved + '%';
            saveEl.appendChild(b);
          }
        }
      }
    });
  };

  Picker.prototype.paintTotals = function (items, subtotal, discounted, pct) {
    var names = items.map(function (v) { return v.options[this.pickAxis]; }, this);
    /* In single mode the option value already is the term, so appending it
       again would read "Default keybinds / Default keybinds". */
    var label = names.length
      ? names.join(' + ') + (!this.single && this.shared ? ' / ' + this.shared : '')
      : 'Nothing selected';

    var sel = document.querySelector('[data-selection-target]');
    if (sel) sel.textContent = label;

    var priceT = document.querySelector('[data-price-target]');
    if (priceT) priceT.textContent = money(discounted);

    var cmp = document.querySelector('[data-compare-target]');
    if (cmp) {
      var show = pct > 0 && subtotal > discounted;
      cmp.textContent = show ? money(subtotal) : '';
      cmp.hidden = !show;
    }

    /* Name the discount rather than just dropping the number: an unexplained
       price change at checkout reads as an error. Reuses the per-day slot,
       which is otherwise unused now. */
    var per = document.querySelector('[data-perday-target]');
    if (per) {
      if (pct > 0 && subtotal > discounted) {
        per.textContent = pct + '% bundle discount applied at checkout';
        per.classList.add('is-discount');
      } else {
        per.textContent = '';
        per.classList.remove('is-discount');
      }
    }

    var sName = document.querySelector('[data-sticky-name]');
    var sPrice = document.querySelector('[data-sticky-price]');
    if (sName) sName.textContent = label;
    if (sPrice) sPrice.textContent = money(discounted);

    var btn = document.querySelector('[data-add-button]');
    if (btn) {
      var lbl = btn.querySelector('[data-add-label]') || btn;
      btn.disabled = items.length === 0;
      lbl.textContent = items.length > 1
        ? 'Add ' + items.length + ' to cart'
        : ((T.strings && T.strings.addToCart) || 'Add to cart');
    }

    // Buy now follows the same buyable / not-buyable state
    var buy = document.querySelector('[data-buy-now]');
    if (buy) buy.disabled = items.length === 0;
  };

  Picker.prototype.paintHint = function (n) {
    var hint = this.root.querySelector('[data-bundle-hint]');
    if (!hint) return;
    /* Don't nudge toward a saving this term cannot earn. */
    if (!termQualifies(this.shared)) { hint.hidden = true; return; }
    var next = null;
    this.tiers.forEach(function (t) {
      if (t.count > n && (!next || t.count < next.count)) next = t;
    });
    if (next) {
      hint.textContent = 'Add ' + (next.count - n) + ' more, save ' + next.percent + '%';
      hint.hidden = false;
    } else {
      hint.hidden = true;
    }
  };

  /* ---------- description panels follow the selection ----------
     The About and Features panels describe the whole product by default,
     which is wrong once a shopper has narrowed to one package. Both are
     rewritten from the selection, and restored to the original markup when
     nothing specific applies. */

  function stash(el) {
    if (el && el.dataset.original === undefined) el.dataset.original = el.innerHTML;
    return el;
  }

  /* key_features is authored as blocks headed "<Name> Package:", so each
     option's list can be sliced out without authoring anything new. */
  Picker.prototype.featuresFor = function (name) {
    if (!this.featureText) return null;
    var lines = this.featureText.split(/\r?\n/);
    var out = [], grabbing = false;

    for (var i = 0; i < lines.length; i++) {
      var line = lines[i];
      var head = /^\s*(.+?)\s+Package\b.*:\s*$/.exec(line);
      if (head) {
        grabbing = head[1].trim().toLowerCase() === name.trim().toLowerCase();
        continue;
      }
      if (grabbing && line.trim()) out.push(line.trim());
    }
    return out.length ? out : null;
  };

  Picker.prototype.paintCopy = function () {
    var self = this;
    var picks = this.selected;

    // --- About panel ---
    var about = document.querySelector('[data-panel-description]') ||
                document.querySelector('.pdp__panel .pdp__rte');
    if (about && Object.keys(this.optionCopy).length) {
      stash(about);
      var parts = picks.filter(function (p) { return self.optionCopy[p]; });

      if (parts.length) {
        about.innerHTML = parts.map(function (p) {
          // name each block only when several are shown, so one pick reads clean
          return (parts.length > 1 ? '<h4 class="pdp__opt-head">' + p + '</h4>' : '') +
                 self.optionCopy[p];
        }).join('');
      } else {
        about.innerHTML = about.dataset.original;
      }
    }

    // --- Features panel ---
    var feat = document.querySelector('.pdp__features');
    if (feat) {
      stash(feat);
      var blocks = picks.map(function (p) {
        var list = self.featuresFor(p);
        if (!list) return '';
        return '<h4 class="pdp__opt-head">' + p + '</h4>' +
               list.map(function (l) { return '<div>' + l + '</div>'; }).join('');
      }).filter(Boolean);

      feat.innerHTML = blocks.length ? blocks.join('') : feat.dataset.original;
    }
  };

  /* ---------- demo video buttons ----------
     One button per selected package that has a video, so selecting Movement
     and Anti Recoil together shows both. The row is created on first use and
     lives directly above the buy buttons, where it reads as part of deciding
     rather than as page furniture. Hidden entirely when nothing selected has
     a video, so products without demos are unaffected. */
  Picker.prototype.paintVideos = function () {
    var self = this;
    if (!this.optionVideos || !Object.keys(this.optionVideos).length) return;

    var row = document.querySelector('[data-video-row]');
    if (!row) {
      /* sits above Buy now when it exists, otherwise above Add to cart */
      var anchor = document.querySelector('[data-buy-now]') ||
                   document.querySelector('[data-add-button]');
      if (!anchor || !anchor.parentNode) return;
      row = document.createElement('div');
      row.className = 'demo-videos';
      row.setAttribute('data-video-row', '');
      anchor.parentNode.insertBefore(row, anchor);
    }

    var picks = this.selected.filter(function (p) { return self.optionVideos[p]; });
    if (!picks.length) { row.hidden = true; row.innerHTML = ''; return; }

    row.innerHTML = picks.map(function (p) {
      var url = String(self.optionVideos[p]);
      /* only ever emit a plain https link, so a bad metafield value cannot
         inject markup or a javascript: URL into the buy box */
      if (!/^https:\/\//i.test(url)) return '';
      var label = picks.length > 1 ? p + ' demo' : 'Watch demo';
      return '<a class="demo-video" href="' + url.replace(/"/g, '&quot;') + '"' +
             ' target="_blank" rel="noopener noreferrer">' +
             '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
             '<path d="M23 12s0-3.9-.5-5.8a3 3 0 0 0-2.1-2.1C18.5 3.6 12 3.6 12 3.6s-6.5 0-8.4.5a3 3 0 0 0-2.1 2.1C1 8.1 1 12 1 12s0 3.9.5 5.8a3 3 0 0 0 2.1 2.1c1.9.5 8.4.5 8.4.5s6.5 0 8.4-.5a3 3 0 0 0 2.1-2.1C23 15.9 23 12 23 12z"/>' +
             '<path d="M9.8 15.5V8.5l6 3.5-6 3.5z" fill="#fff"/>' +
             '</svg><span>' + label + '</span></a>';
    }).filter(Boolean).join('');

    row.hidden = !row.innerHTML;
  };

  /* Hardware notice.
     Every selected package gets its own line, because "required" and
     "partial" mean different things and collapsing them to one sentence
     misstates what the shopper actually needs. Tone follows the strictest
     state present: any hard requirement makes the whole notice red, even
     when it is mixed with a partial one. */
  Picker.prototype.paintHardware = function () {
    var notice = document.querySelector('[data-hardware-notice]');
    if (!notice) return;

    var self = this;
    var required = [], partial = [], clear = [];

    this.selected.forEach(function (val) {
      var st = self.hardware[val];
      if (st === true || st === 'required') required.push(val);
      else if (st === 'partial') partial.push(val);
      else clear.push(val);
    });

    var title = notice.querySelector('[data-hardware-title]');
    var body  = notice.querySelector('[data-hardware-body]');
    var icon  = notice.querySelector('[data-hardware-icon]');
    var d = notice.dataset;

    notice.classList.remove('notice--ok', 'notice--partial');

    function fill(t, b, ic) {
      if (title) title.textContent = t;
      if (body) body.innerHTML = b;
      if (icon) icon.textContent = ic;
    }

    // join names the way a person would: "A", "A and B", "A, B and C"
    function names(list) {
      if (list.length === 1) return list[0];
      if (list.length === 2) return list[0] + ' and ' + list[1];
      return list.slice(0, -1).join(', ') + ' and ' + list[list.length - 1];
    }

    if (!this.selected.length) { notice.hidden = true; return; }

    // reason per package, so a mixed bundle explains each half
    var lines = [];

    if (required.length) {
      lines.push('<strong>' + names(required) + '</strong> ' +
        (required.length === 1 ? 'requires' : 'require') +
        ' the microcontroller to run.');
    }

    partial.forEach(function (val) {
      var cfg = self.partial[val] || {};
      // the metafield body is authored copy; fall back to a plain sentence
      lines.push('<strong>' + val + '</strong> ' +
        (cfg.short || 'only needs the board for Auto Armor Swap.'));
    });

    if (clear.length) {
      lines.push('<strong>' + names(clear) + '</strong> ' +
        (clear.length === 1 ? 'needs' : 'need') + ' no extra hardware.');
    }

    if (required.length) {
      // red: something in the bundle cannot work without the board at all
      fill(d.titleRequired || 'RP2350A microcontroller required',
           lines.join('<br>'), '!');
    } else if (partial.length) {
      // amber: the board only unlocks certain features
      notice.classList.add('notice--partial');
      var solo = partial.length === 1 ? (this.partial[partial[0]] || {}) : {};
      fill(solo.title || 'RP2350A needed for some features',
           lines.join('<br>'), '!');
    } else {
      notice.classList.add('notice--ok');
      fill(d.titleOptional || 'No extra hardware needed', lines.join('<br>'), '✓');
    }

    notice.hidden = false;
  };

  /* checkout: true skips the cart and posts straight to checkout */
  Picker.prototype.add = function (checkout) {
    if (!this.current || !this.current.length) return;
    var self = this;
    var routes = T.routes || {};

    /* whichever button was pressed shows the progress, and both are locked
       so a second click cannot add the bundle twice */
    var btn = checkout
      ? document.querySelector('[data-buy-now]')
      : document.querySelector('[data-add-button]');
    var other = checkout
      ? document.querySelector('[data-add-button]')
      : document.querySelector('[data-buy-now]');
    var lbl = btn && (btn.querySelector('[data-add-label]')
                   || btn.querySelector('[data-buy-now-label]')
                   || btn);
    var original = lbl ? lbl.textContent : '';

    if (btn) btn.disabled = true;
    if (other) other.disabled = true;
    if (lbl) lbl.textContent = checkout ? 'Redirecting...' : 'Adding...';

    fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: this.current.map(function (v) { return { id: v.id, quantity: 1 }; })
      })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .then(function () {
        // straight to checkout, no cart step and no drawer
        if (checkout) { window.location.href = '/checkout'; return; }

        if (lbl) lbl.textContent = (T.strings && T.strings.added) || 'Added';
        if (window.RaidCart && window.RaidCart.refresh) {
          return window.RaidCart.refresh().then(function () {
            if (T.cartType === 'drawer' && window.RaidCart.open) window.RaidCart.open();
            else window.location.href = routes.cart_url;
          });
        }
        window.location.href = routes.cart_url;
      })
      .catch(function (err) {
        var box = document.querySelector('[data-form-error]');
        if (box) {
          box.textContent = (err && err.description) || 'Could not add to cart';
          box.hidden = false;
          setTimeout(function () { box.hidden = true; }, 6000);
        }
        if (lbl) lbl.textContent = original;
      })
      .then(function () {
        setTimeout(function () {
          if (btn) btn.disabled = false;
          if (other) other.disabled = false;
          self.update();
        }, 1200);
      });
  };

  function init() {
    document.querySelectorAll('[data-bundle-builder]').forEach(function (el) {
      if (!el.__picker) el.__picker = new Picker(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
